<template>
  <div>
    <form
      class="grid"
      @submit.prevent="sendRequest"
    >
      <Panel class="col-12">
        <template #header>
          <p class="font-bold p-0 pl-2 m-0">
            {{ $t('specialrequestcreatePage.generalinformations') }}
          </p>
        </template>
        <div class="p-input mb-3">
          <label
            for="reasonRequest"
            class="required-input"
          >{{ $t('entity.specialrequest.reasonRequest') }}</label>
          <Dropdown
            id="reasonRequest"
            v-model="v$.specialRequest.reasonRequest.$model"
            :options="reasonsRequest"
            :option-label="(value) => value.label"
            class="col-12 mt-2 p-0"
            :class="{'invalid-input': v$.specialRequest.reasonRequest.$error }"
            required
          >
            <template #value="slotProps">
              <span v-if="slotProps.value">
                {{ $t(slotProps.value.label) }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ $t(slotProps.option.label) }}</span>
            </template>
          </Dropdown>
        </div>
        <div v-if="specialRequest.reasonRequest?.value === 0" class="p-input mb-3">
          <label
            for="localizingMaterials"
            class="required-input"
          >{{ $t('entity.specialrequest.localizingMaterials') }}</label>
          <Dropdown
            id="localizingMaterials"
            v-model="v$.specialRequest.localizingMaterials.$model"
            :options="materialLocalisations"
            :option-label="(value) => value.label"
            class="col-12 mt-2 p-0"
            :class="{'invalid-input': v$.specialRequest.localizingMaterials.$error }"
            required
          >
            <template #value="slotProps">
              <span v-if="slotProps.value">
                {{ $t(slotProps.value.label) }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ $t(slotProps.option.label) }}</span>
            </template>
          </Dropdown>
        </div>
        <div v-if="specialRequest.localizingMaterials?.value === 2" class="p-input mb-3">
          <label
            for="detailsOtherLocalizingMaterials"
            class="required-input"
          >{{ $t('entity.specialrequest.detailsOtherLocalizingMaterials') }}</label>
          <InputText
            id="detailsOtherLocalizingMaterials"
            v-model="v$.specialRequest.detailsOtherLocalizingMaterials.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.detailsOtherLocalizingMaterials.$error }"
            type="text"
            required
          />
        </div>
        <div v-if="specialRequest.reasonRequest?.value === 1" class="p-input mb-3">
          <label
            for="vehicleTypes"
            class="required-input"
          >{{ $t('entity.specialrequest.vehicleTypesLabel') }}</label>
          <MultiSelect
            id="vehicleTypes"
            v-model="v$.specialRequest.vehicleTypes.$model"
            :options="vehicleTypes"
            :option-label="(value) => $t(value.label)"
            class="col-12 mt-2 p-0"
            :class="{'invalid-input': v$.specialRequest.vehicleTypes.$error }"
            required
          >
            <template #option="slotProps">
              <span>{{ $t(slotProps.option.label) }}</span>
            </template>
          </MultiSelect>
        </div>
        <div v-if="specialRequest.vehicleTypes.map(vehicle => vehicle.value).indexOf(8) !== -1" class="p-input mb-3">
          <label
            for="detailsOtherVehiculeType"
            class="required-input"
          >{{ $t('entity.specialrequest.detailsOtherVehiculeType') }}</label>
          <InputText
            id="detailsOtherVehiculeType"
            v-model="v$.specialRequest.detailsOtherVehiculeType.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.detailsOtherVehiculeType.$error }"
            type="text"
            required
          />
        </div>
        <div class="p-input mb-3">
          <label
            for="wishedMeetingAddress"
            class="required-input font-semibold"
          >{{ $t('entity.specialrequest.wishedMeetingAddress') }}</label>
          <InputAddress
            id="wishedMeetingAddress"
            v-model="v$.specialRequest.wishedMeetingAddress.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.wishedMeetingAddress.$error }"
            type="text"
          />
        </div>
        <EquipmentTypesField :model-value="v$.specialRequest.specialRequestEquipmentslist.$model"></EquipmentTypesField>
        <div class="p-input mb-3 mt-4">
          <label
            for="commentary"
          >{{ $t('entity.specialrequest.commentary') }}</label>
          <Textarea
            id="commentary"
            v-model="v$.specialRequest.commentary.$model"
            class="col-12 mt-2"
            type="text"
            :auto-resize="true"
            :class="{'invalid-input': v$.specialRequest.commentary.$error }"
          />
        </div>
        <div class="p-input mb-3">
          <span class="block col-12 mb-3 px-0 font-bold">{{ $t('entity.specialrequest.availabilityDatetime') }}</span>
          <div class="flex">
            <div class="col-6 p-0 pr-4">
              <label
                for="startingAvailabilityDatetime"
                class="required-input col-2 px-0"
              >{{ $t('entity.specialrequest.startAvailabilityDatetime') }}</label>
              <Calendar
                id="startingAvailabilityDatetime"
                v-model="v$.specialRequest.startingAvailabilityDatetime.$model"
                show-time
                hour-format="24"
                :class="{'invalid-input': v$.specialRequest.startingAvailabilityDatetime.$error }"
                class="col-12 px-0"
                placeholder=""
              />
            </div>
            <div class="col-6 p-0">
              <label
                for="endingAvailabilityDateTime"
                class="required-input col-2 px-0"
              >{{ $t('entity.specialrequest.endAvailabilityDatetime') }}</label>
              <Calendar
                id="endingAvailabilityDateTime"
                v-model="v$.specialRequest.endingAvailabilityDateTime.$model"
                show-time
                hour-format="24"
                :class="{'invalid-input': v$.specialRequest.endingAvailabilityDateTime.$error }"
                class="col-12 px-0"
              />
              <div
                v-for="error of v$.specialRequest.endingAvailabilityDateTime.$errors"
                :key="error.$uid"
                class="input-errors mt-1"
              >
                <div class="error-msg">
                  {{ error.$message }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Panel>
      <Panel class="col-12">
        <template #header>
          <p class="font-bold p-0 pl-2 m-0">
            {{ $t('specialrequestcreatePage.sitecontact') }}
          </p>
        </template>
        <div class="p-input mb-3">
          <label
            for="lastName"
            class="required-input"
          >{{ $t('entity.specialrequest.specialRequestContact.lastName') }}</label>
          <InputText
            id="lastName"
            v-model="v$.specialRequest.specialRequestContact.lastName.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.specialRequestContact.lastName.$error }"
            type="text"
            required
          />
        </div>
        <div class="p-input mb-3">
          <label
            for="firstName"
            class="required-input"
          >{{ $t('entity.specialrequest.specialRequestContact.firstName') }}</label>
          <InputText
            id="firstName"
            v-model="v$.specialRequest.specialRequestContact.firstName.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.specialRequestContact.firstName.$error }"
            type="text"
            required
          />
        </div>
        <div class="p-input mb-3">
          <label
            for="profession"
            class="required-input"
          >{{ $t('entity.specialrequest.specialRequestContact.profession') }}</label>
          <InputText
            id="profession"
            v-model="v$.specialRequest.specialRequestContact.profession.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.specialRequestContact.profession.$error }"
            type="text"
            required
          />
        </div>
        <div class="p-input mb-3">
          <label
            for="company"
          >{{ $t('entity.specialrequest.specialRequestContact.company') }}</label>
          <InputText
            id="company"
            v-model="v$.specialRequest.specialRequestContact.company.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.specialRequestContact.company.$error }"
            type="text"
          />
        </div>
        <div class="p-input mb-3">
          <label
            for="phoneNumber"
            class="required-input"
          >{{ $t('entity.specialrequest.specialRequestContact.phoneNumber') }}</label>
          <InputPhoneNumber
            id="phoneNumber"
            v-model:phoneNumberCountryCode="v$.specialRequest.specialRequestContact.phoneNumberCountryCode.$model"
            v-model:phoneNumber="v$.specialRequest.specialRequestContact.phoneNumber.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.specialRequestContact.phoneNumber.$error }"
          />
          <div
            v-for="error of v$.specialRequest.specialRequestContact.phoneNumber.$errors"
            :key="error.$uid"
            class="input-errors"
          >
            <div class="error-msg">
              {{ error.$message }}
            </div>
          </div>
        </div>
        <div class="p-input mb-3">
          <label
            for="email"
          >{{ $t('entity.specialrequest.specialRequestContact.email') }}</label>
          <InputText
            id="email"
            v-model="v$.specialRequest.specialRequestContact.email.$model"
            class="col-12 mt-2"
            :class="{'invalid-input': v$.specialRequest.specialRequestContact.email.$error }"
            type="email"
            autocomplete="email"
            @blur="setEmailToNullIfEmpty"
          />
          <div
            v-for="error of v$.specialRequest.specialRequestContact.email.$errors"
            :key="error.$uid"
            class="input-errors"
          >
            <div class="error-msg">
              {{ error.$message }}
            </div>
          </div>
        </div>
      </Panel>
      <div class="col-12">
        <Message
          v-if="errors?.length > 0"
          severity="error"
          :closable="false"
        >
          <ul class="list-none m-0 p-0">
            <li
              v-for="error of errors"
              :key="error.content"
            >
              {{ $t(error) }}
            </li>
          </ul>
        </Message>
        <div class="text-right mb-8">
          <div
            v-if="isSaving"
            class="inline-block mr-4"
          >
            <div class="loader-dots">
              <div />
              <div />
              <div />
            </div>
          </div>

          <Button
            type="submit"
            class="p-button-rounded p-button-outlined"
            :disabled="v$.$invalid || isSaving"
            icon="pi pi-check"
            :label="$t('action.crud.create')"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Button from "primevue/button";
import Message from "primevue/message";
import Panel from "primevue/panel";
import {useVuelidate} from "@vuelidate/core";
import {email, phoneNumberPattern, required, requiredIf, isAfterDate} from "@/i18n/i18nValidators";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import EquipmentTypesField from "@/components/equipmenttype/EquipmentTypesField.vue";
import InputAddress from "@/components/InputAddress.vue";
import Textarea from "primevue/textarea";
import Calendar from "primevue/calendar";
import SpecialRequestCreateRequest from "@/models/dto/requests/SpecialRequestCreateRequest";
import InputPhoneNumber from "@/components/InputPhoneNumber.vue";

export default {
  name: 'SpecialRequestForm',
  components: {
    InputPhoneNumber,
    InputAddress, EquipmentTypesField, Button, Message, Dropdown, Panel, InputText, MultiSelect, Textarea, Calendar},
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      specialRequest: {
        reasonRequest: null,
        localizingMaterials: null,
        detailsOtherLocalizingMaterials: null,
        vehicleTypes: [],
        detailsOtherVehiculeType: null,
        specialRequestEquipmentslist: [],
        commentary: null,
        startingAvailabilityDatetime: null,
        endingAvailabilityDateTime: null,
        wishedMeetingAddress: null,
        specialRequestContact: {
          lastName : null,
          firstName : null,
          profession : null,
          company : null,
          phoneNumberCountryCode: 'FR',
          phoneNumber : null,
          email : null,
        }
      },

      isSaving: false,
      reasonsRequest: [],
      materialLocalisations: [],
      vehicleTypes: [],
      errors: []
    }
  },
  validations() {
    return {
      specialRequest: {
        reasonRequest: { required },
        localizingMaterials: { required: requiredIf(function () {
            return this.specialRequest.reasonRequest?.value === 0;
          }) },
        detailsOtherLocalizingMaterials: { required: requiredIf(function () {
            return this.specialRequest.localizingMaterials?.value === 2;
          }) },
        vehicleTypes: { required: requiredIf(function () {
            return this.specialRequest.reasonRequest?.value === 1;
          }) },
        detailsOtherVehiculeType: { required: requiredIf(function () {
            return this.specialRequest.vehicleTypes.map(vehicle => vehicle.label).indexOf(this.$t("entity.specialrequest.vehicleTypes.other")) !== -1;
          }) },
        specialRequestEquipmentslist: { required },
        commentary: {},
        startingAvailabilityDatetime: { required },
        endingAvailabilityDateTime: { required, isAfterDate: isAfterDate(this.specialRequest.startingAvailabilityDatetime) },
        wishedMeetingAddress: { required },
        specialRequestContact: {
          lastName: { required },
          firstName: { required },
          profession: { required },
          company: {},
          phoneNumberCountryCode: { required },
          phoneNumber: { required, phoneNumberPattern: phoneNumberPattern(this.specialRequest.specialRequestContact.phoneNumberCountryCode) },
          email: { email }
        },
      }
    }
  },
  async mounted() {
    this.$watch('specialRequest.reasonRequest', (reason) => {
      if (reason.value === 0) {
        // Clear the vehicle information if the reason is no longer materials in vehicle
        this.specialRequest.vehicleTypes = [];
        this.specialRequest.detailsOtherVehiculeType = null;
      } else {
        // Clear the location information if the reason is no longer equipment stored at a fixed location
        this.specialRequest.localizingMaterials = null;
        this.specialRequest.detailsOtherLocalizingMaterials = null;
      }
    });

    // Clear the other localizing materials field if the location is no longer other location and specify
    this.$watch('specialRequest.localizingMaterials', () => {
      this.specialRequest.detailsOtherLocalizingMaterials = null;
    });

    // Clear the other vehicle type field if the vehicle types list no longer includes other
    this.$watch('specialRequest.vehicleTypes', (vehicleTypes) => {
      if (!vehicleTypes.some(type => type.value === 8)) {
        this.specialRequest.detailsOtherVehiculeType = null;
      }
    });

    this.reasonsRequest = [
      {value: 0, label: 'entity.specialrequest.reasons.localizingmaterials'},
      {value: 1, label: 'entity.specialrequest.reasons.materialsinvehicle'}
    ];
    this.materialLocalisations = [
      {value: 0, label: 'entity.specialrequest.materialLocalisations.warehouse'},
      {value: 1, label: 'entity.specialrequest.materialLocalisations.onsite'},
      {value: 2, label: 'entity.specialrequest.materialLocalisations.other'}
    ];
    this.vehicleTypes = [
      {value: 0, label: 'entity.specialrequest.vehicleTypes.outsidebroadcastvan'},
      {value: 1, label: 'entity.specialrequest.vehicleTypes.sngvehicle'},
      {value: 2, label: 'entity.specialrequest.vehicleTypes.car'},
      {value: 3, label: 'entity.specialrequest.vehicleTypes.motorbike'},
      {value: 4, label: 'entity.specialrequest.vehicleTypes.plane'},
      {value: 5, label: 'entity.specialrequest.vehicleTypes.helicopter'},
      {value: 6, label: 'entity.specialrequest.vehicleTypes.boat'},
      {value: 7, label: 'entity.specialrequest.vehicleTypes.drone'},
      {value: 8, label: 'entity.specialrequest.vehicleTypes.other'}
    ];
  },
  methods: {
    async sendRequest() {
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) return;

      this.isSaving = true;
      const requestBody = new SpecialRequestCreateRequest({
        reasonRequest: this.specialRequest.reasonRequest?.value,
        localizingMaterials: this.specialRequest.localizingMaterials?.value,
        detailsOtherLocalizingMaterials: this.specialRequest.detailsOtherLocalizingMaterials,
        vehicleTypes: this.specialRequest.vehicleTypes?.map(vehicle => vehicle.value),
        detailsOtherVehiculeType: this.specialRequest.detailsOtherVehiculeType,
        specialRequestEquipmentslist: this.specialRequest.specialRequestEquipmentslist,
        commentary: this.specialRequest.commentary,
        answer: this.specialRequest.answer,
        status: this.specialRequest.status,
        creationDate: Date.now(),
        startingAvailabilityDatetime: this.specialRequest.startingAvailabilityDatetime,
        endingAvailabilityDateTime: this.specialRequest.endingAvailabilityDateTime,
        wishedMeetingAddress: this.specialRequest.wishedMeetingAddress,
        specialRequestContact: this.specialRequest.specialRequestContact
      })
      try {
        await this.$specialRequestService.create(requestBody)
        this.success = true;
        this.$emitter.emit('toast', { severity: 'success', message: 'specialrequestcreatePage.toast.success' })
        this.errors = null;
        this.isSaving = false;
        this.toAppointments();
      } catch (err) {
        this.success = false;
        this.errors = err.response.data;
        this.isSaving = false;
      }
    },
    toAppointments() {
      this.$router.push({ name: 'userAppointment' })
    },
    setEmailToNullIfEmpty() {
      if (this.specialRequest
        && this.specialRequest.specialRequestContact
        && this.specialRequest.specialRequestContact.email === '')  {
        this.specialRequest.specialRequestContact.email = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
